<template>
  <button role="navigation" type="button" class="btn-back" @click="navigate">
    <div class="btn-back__icon">
      <vb-icon name="arrow_l" :size="18" :color="sass('info')"/>
    </div>
    <div class="btn-back__text">
      <span v-if="text">{{ text }}</span>
      <span v-else>Torna indietro</span>
    </div>
  </button>
</template>

<script> 
export default {
  name: 'btn-back',
  components: {},
  props: {
    text: String,
    path: {
      type: String,
      default: '',
    },
  }, 
  methods: {
    navigate() {
      if (this.path) {
        this.$router.push(this.path);
        return;
      }
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.btn-back {
  margin-left: 0;
  color: var(--info);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: $font-size-base;
  font-weight: 400;
  line-height: 1;

  width: max-content;
  background: transparent;
  border: none;

  &:hover,
  &:hover * {
    text-decoration: none;
  }

  svg {
    height: 14px;
    margin-right: 8px;
    margin-left: -4px; 
  }
}
</style>
